import { css, type Theme } from "@emotion/react";

export const categoryL1Selected = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMuted};
  padding: 0.75rem;
  border-radius: 0.5rem;
  border-width: 0;
  margin-bottom: 0.5rem;
`;

export const categoryL2 = css`
  padding-left: 0.75rem;
  border-width: 0;
  padding-top: 0;
  padding-bottom: 0.5rem;
`;

export const categoryL3 = css`
  padding-left: 1.75rem;
  border-width: 0;
  padding-top: 0;
  padding-bottom: 0.5rem;
`;

export const categoryL4 = css`
  padding-left: 2.75rem;
  border-width: 0;
  padding-top: 0;
  padding-bottom: 0.5rem;
`;

export const accordion = () => css`
  position: relative;
  padding-right: 0;

  // hide accordion expand/collapse chevron
  > div > div > div > svg {
    display: none;
  }
`;

export const accordionExpanded = css`
  > div {
    padding-top: 0.2rem;
  }
`;

export const icon = (theme: Theme) => css`
  color: ${theme.text.body};
`;
